/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId = FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId);
    }

    return {};
}

